import AppChrome from '../../components/AppChrome'
import Hero from '../../components/Hero'
import CourseSessions from '../../components/CourseSessions'

export { getServerSideProps } from '../../graphql/course'

function CoursePage( { entry: course, courseSessions } ) {
  return (
    <AppChrome>
      <Hero>
        <strong>{ course.title }</strong>
        { course.pageIntro }
      </Hero>
      <CourseSessions sessions={ courseSessions } />
    </AppChrome>
  )
}

export default CoursePage
